import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';
import {startOfMonth, subMonths} from "date-fns";
import moment from "moment";

import {stateDate} from "../../../../utils/formatDate";

const initialState: any = {
    limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
    page: 1,
    data: [],
    applicationListInputValues: {
    },
    modifiedDate: {
        from: moment(
            stateDate(startOfMonth(subMonths(new Date(), 1)))
        ).format("DD/MM/YYYY"),
        to: moment(stateDate(new Date())).format("DD/MM/YYYY"),
    },
    filters: {
        applicantCondition: [],
        desired: [],
        statuses: [],
        projects: []
    },
    isPending: false
};

export const createApplicationSlice = createSlice({
    name: 'applicationList',
    initialState,
    reducers: {

        reducerGetApplicationsList: (state: Draft<any>, action: PayloadAction<any>) => {
            state.data = action.payload.data;
            state.pages = action.payload.pages
            state.count = action.payload.count
            state.checkboxes = action.payload.data?.reduce(
                (acc: any, vacancy: any) => {
                    const vacancyId = vacancy.application.id
                    acc[vacancyId] = false;
                    return acc;
                },
                {}
            );
        },
        reducerSelectedApplicationsId: (state: Draft<any>, action: PayloadAction<any>) => {
            state.selectedApplicationsId = action.payload;
        },
        reducerApplicationsListInputValues: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.applicationListInputValues = {...state.applicationListInputValues, ...action.payload};
            state.modifiedDate = {
                from: moment(action.payload.modifiedDate.from).format(
                    "DD/MM/YYYY"),
                to: moment(action.payload.modifiedDate.to).format(
                    "DD/MM/YYYY"),
            }
        },
        reducerApplicationFiltersList: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.filters.applicantCondition = action.payload.data.applicantConditions?.map(
                (option: any, ind: number) => ({
                    value: option,
                    label: option,
                })
            );

            state.filters.desired = action.payload.data.desiredPositions?.map(
                (option: any, ind: number) => ({
                    value: option,
                    label: option,
                })
            );

            state.filters.statuses = action.payload.data.status?.map(
                (option: any) => ({
                    value: Object.keys(option)[0],
                    label: Object.values(option)[0],
                })
            );

            state.filters.projects = action.payload.data.projects?.map(
                (option: any) => ({
                    value: option.id,
                    label: option.name,
                })
            );
        },
        reducerSingleApplicationMultiSelect: (state: Draft<any>, action: PayloadAction<any>) => {
            if (action.payload.projects) {
                state.applicationListInputValues = {
                    ...state.applicationListInputValues,
                    projects: action.payload.projects.map((project: any) => ({id: project}))
                };
            } else {
                state.applicationListInputValues = {...state.applicationListInputValues, ...action.payload}
            }
        },
    },
});

export const {
    reducerGetApplicationsList,
    reducerSelectedApplicationsId,
    reducerApplicationsListInputValues,
    reducerApplicationFiltersList,
    reducerSingleApplicationMultiSelect
} = createApplicationSlice.actions;

export default createApplicationSlice.reducer;
